export const LocaleTypes = ['ru', 'en', 'lv'] as const;
